<div  v-bind:class="getClassName">
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
</div>

